import { create } from 'zustand'

type uSearchStoreState = { isSearchOpen: boolean }

type uSearchStoreActions = {
  setIsSearchOpen: (flag: boolean) => void
}

type uSearchStore = uSearchStoreActions & uSearchStoreState

export const useUSearchStore = create<uSearchStore>()((set) => ({
  isSearchOpen: false,
  setIsSearchOpen: (open) => {
    set({
      isSearchOpen: open
    })
  }
}))
